import { render, staticRenderFns } from "./TurnitinServiceIntegration.vue?vue&type=template&id=aa151454&scoped=true&"
import script from "./TurnitinServiceIntegration.vue?vue&type=script&lang=js&"
export * from "./TurnitinServiceIntegration.vue?vue&type=script&lang=js&"
import style0 from "./TurnitinServiceIntegration.vue?vue&type=style&index=0&id=aa151454&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa151454",
  null
  
)

export default component.exports